import { IonHeader, IonToast, IonToolbar } from "@ionic/react";
import { useEffect, useState, useContext } from "react";
import ReactPlayer from "react-player";
import { Repeat } from "../global";

function YouTubePlayer(props){

  const [showToast, setShowToast] = useState(false);
  const [toastText, setToastText] = useState("");
  const [isOnline, setIsOnline] = useState(false)
  const [repeat, ] = useContext(Repeat)

    useEffect(()=>{
      if(!navigator.onLine){
        setToastText("Please connect to the internet to show your audio")
        setShowToast(true)
        setIsOnline(false)
        }else {
          setIsOnline(true)
        }
      const handleOnlineStatusChange = () => {
        if(navigator.onLine){
            setTimeout(()=>{
              setIsOnline(true)
            }, 100)
          }
       }
       window.addEventListener('online', handleOnlineStatusChange)
       return () => {
        window.removeEventListener('online', handleOnlineStatusChange)
       }
    },[props.userAudios[props.name].linkaddress])

    return(
      <>{isOnline ? <IonHeader className="print-hide">
       <IonToolbar color={props.colorh} mode="md">
    {props.userAudios[props.name].linkaddress.indexOf("drive.google.com") === -1 ? <ReactPlayer
     controls
    loop={repeat ? true : false}
    width="100%" height='56.25vw' style={{maxHeight:"34vh"}} url={props.userAudios[props.name].linkaddress} />
    : <div style={{ width: "100%", textAlign: "center" }}>
     <iframe title="Vaishnava Song" src={props.userAudios[props.name].linkaddress} style={{ width: "100%", height: '56.25vw',maxHeight:"16vh" }}></iframe> 
   </div>}

    </IonToolbar>
    </IonHeader> : null}
    <IonToast isOpen={showToast} onDidDismiss={() => setShowToast(false)} message={toastText} duration={4000} />
    </>
    );



}

export default YouTubePlayer